/* eslint-disable react/prop-types */
import React from 'react'
import { HistoryOutlined } from '@ant-design/icons'
import { observer } from 'mobx-react-lite'
import { runInAction } from 'mobx'

/*
 * _itm could be also subtask class
 */
/**
 * HistoryView component renders a history icon which, when clicked,
 * opens a modal drawer displaying the history of an item or subtask.
 *
 * @component
 * @param {Object} props - The component props.
 * @param {Object} props._itm - The item or subtask instance containing history methods and displayName.
 * @param {Object} props.uiStore - The MobX UI store used to open modals.
 * @param {string} [props.category='progress'] - The history category key to fetch from the item's history.
 * @param {string} [props.historyKey='history-drawer'] - The modal key under which to store the history data.
 * @param {Function} [props.getHistory] - Optional custom function to retrieve history for a specific subtask ID.
 * @returns {JSX.Element} An icon that opens the history drawer on click.
 */
const HistoryView = observer(
	({
		_itm,
		uiStore,
		category = 'progress',
		historyKey = 'history-drawer',
		getHistory
	}) => {
		const handleHistoryOpen = (id) => {
			const hasRecurrence =
				(_itm?.recurrence?.type && _itm?.recurrence?.type !== '') ||
				false
			const historyData = getHistory
				? getHistory(id)
				: (hasRecurrence
						? _itm.history.getHistory(category)
						: _itm.history.getHistoryItem(category, id)) || []
			const historyItem = { name: _itm.displayName, history: historyData }
			runInAction(() => {
				uiStore.setModal(historyKey, {
					visible: true,
					item: historyItem
				})
			})
		}
		return (
			<HistoryOutlined
				key="info"
				onClick={() => handleHistoryOpen(_itm.id)}
			/>
		)
	}
)

export default HistoryView
